import * as React from 'react';
import { FirebasePerformanceContext } from 'src/_shared/context/firebase-performance';
export default function withFirebasePerformance(WrappedComponent) {
    const ComponentWithFirebasePerformance = (props) => {
        const { initTracker, recordPerformance } = React.useContext(FirebasePerformanceContext);
        return (React.createElement(WrappedComponent, Object.assign({ initFirebasePerformanceTracker: initTracker, recordFirebasePerformance: recordPerformance }, props)));
    };
    return ComponentWithFirebasePerformance;
}
